module.exports = __webpack_public_path__ + "static/media/brios-semillas-b.18c743e5.webp";